import { getElementParents } from '../helpers/general';

document.querySelectorAll('.checkbox-select .form-field').forEach((formField) => {
  formField.addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelectorAll('.checkbox-select .middleColumn.active').forEach((activeColumn) => {
      activeColumn.classList.remove('active');
    });

    e.currentTarget.closest('.middleColumn').classList.toggle('active');
  });
});

document.querySelectorAll('input:not([type=checkbox]), select, textarea').forEach((formElement) => {
  formElement.addEventListener('focus', (e) => {
    e.currentTarget.classList.remove('active');
  });
});

document.querySelectorAll('.checkbox-list-close').forEach((checkboxListClose) => {
  checkboxListClose.addEventListener('click', (e) => {
    e.preventDefault();

    e.currentTarget.closest('.middleColumn').classList.remove('active');
  });
});

document.querySelectorAll('.checkbox-select input').forEach((checkboxSelectInput) => {
  checkboxSelectInput.addEventListener('change', (e) => {
    const parentSelect = getElementParents(e.currentTarget, '.checkbox-select')[0];
    const selectedChecks = [];

    parentSelect.querySelectorAll('input:checked').forEach((checkedInput) => {
      selectedChecks.push(checkedInput.value);
    });

    parentSelect.querySelector('.form-field').innerText = selectedChecks.join(', ');
  });
});

document.querySelectorAll('.checkbox-select').forEach((checkboxSelect) => {
  const selectedChecks = [];

  checkboxSelect.querySelectorAll('input:checked').forEach((checkedInput) => {
    selectedChecks.push(checkedInput.value);
  });

  const formField = checkboxSelect.querySelector('.form-field');

  if (formField) {
    formField.innerText = selectedChecks.join(', ');
  }
});
